import { render, staticRenderFns } from "./DownloadAppComponent.vue?vue&type=template&id=b3da4c90&scoped=true"
import script from "./DownloadAppComponent.vue?vue&type=script&lang=js"
export * from "./DownloadAppComponent.vue?vue&type=script&lang=js"
import style0 from "./DownloadAppComponent.vue?vue&type=style&index=0&id=b3da4c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3da4c90",
  null
  
)

export default component.exports